var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 25.379,
    viewBox: "0 0 46 25.379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".green{fill:#29ed87;}.white{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23 -27.311)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "green",
    d: "M1490.485,544.454a23,23,0,0,0-23,23h5.675a2.1,2.1,0,0,0,2.1-1.825,15.281,15.281,0,0,1,3.394-7.925q.468-.568.99-1.089a15.331,15.331,0,0,1,26.065,9.007,2.1,2.1,0,0,0,2.1,1.832h5.681a23,23,0,0,0-23-23",
    transform: "translate(-1444.485 -517.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M1505.592,570.4a5.952,5.952,0,1,1-5.952,5.952,5.952,5.952,0,0,1,5.952-5.952",
    transform: "translate(-1459.94 -529.613)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/LogoMobile.df931eb99da678a52e97266f2bc0e59e.svg";
export { ForwardRef as ReactComponent };